import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';

import AudioTieredBundle from 'Features/Bundle/components/Templates/AudioTemplates/AudioTieredBundle';
import FiveCardRow from 'Features/Bundle/components/Templates/GridTemplates/FiveCardRow';
import FourCardRow from 'Features/Bundle/components/Templates/GridTemplates/FourCardRow';
import SixCardRow from 'Features/Bundle/components/Templates/GridTemplates/SixCardRow';
import ThreeCardRow from 'Features/Bundle/components/Templates/GridTemplates/ThreeCardRow';
import TwoCardRow from 'Features/Bundle/components/Templates/GridTemplates/TwoCardRow';

function AudioBundleTemplateSelector({
  product,
  bundleTiers,
  switchCarouselGame,
}) {
  if (product.bundles.length > 1) {
    return (
      <AudioTieredBundle
        bundleTiers={bundleTiers}
        product={product}
        switchCarouselGame={switchCarouselGame}
        payWhatYouWant={product.pay_what_you_want}
      />
    );
  }

  const filteredBundleTier = sortBy(bundleTiers[0].games, ['sort_order']).filter(game => game.display);

  // If layout_type has been set, this should supercede all other templates

  if (product.layout_type === '2') {
    return (
      <section className="fan-grid-container">
        <TwoCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={product.slug}
        />
      </section>
    );
  }

  if (product.layout_type === '3') {
    return (
      <section className="fan-grid-container">
        <ThreeCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={product.slug}
        />
      </section>
    );
  }

  if (product.layout_type === '4') {
    return (
      <section className="fan-grid-container">
        <FourCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={product.slug}
        />
      </section>
    );
  }

  if (product.layout_type === '5') {
    return (
      <section className="fan-grid-container">
        <FiveCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={product.slug}
        />
      </section>
    );
  }

  if (product.layout_type === '6') {
    return (
      <section className="fan-grid-container">
        <SixCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={product.slug}
        />
      </section>
    );
  }

  if (
    filteredBundleTier.length === 5 ||
    filteredBundleTier.length === 10 ||
    filteredBundleTier.length === 15 ||
    filteredBundleTier.length === 20 ||
    filteredBundleTier.length === 25
  ) {
    return (
      <section className="fan-grid-container">
        <FiveCardRow
          filteredBundleTier={filteredBundleTier}
          switchCarouselGame={switchCarouselGame}
          bundleSlug={product.slug}
        />
      </section>
    );
  }

  return (
    <section className="fan-grid-container">
      <FourCardRow
        filteredBundleTier={filteredBundleTier}
        switchCarouselGame={switchCarouselGame}
        bundleSlug={product.slug}
      />
    </section>
  );
}

AudioBundleTemplateSelector.propTypes = {
  product: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    cover: PropTypes.string,
    presale: PropTypes.bool,
    type: PropTypes.string,
    currentDiscount: PropTypes.shape({}),
    price: PropTypes.shape({}),
    fullPrice: PropTypes.shape({}),
    hideDiscount: PropTypes.bool,
    bundles: PropTypes.arrayOf(PropTypes.shape({})),
    endDate: PropTypes.string,
    productId: PropTypes.string,
    soldOut: PropTypes.bool,
    regions_included: PropTypes.array,
    regions_excluded: PropTypes.array,
    giveaway: PropTypes.bool,
    platforms: PropTypes.shape({
      windows: PropTypes.bool,
      mac: PropTypes.bool,
      linux: PropTypes.bool,
    }),
    drm: PropTypes.shape({}),
  }),
  switchCarouselGame: PropTypes.func,
  bundleTiers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

AudioBundleTemplateSelector.defaultProps = {
  product: {
    _id: '',
    name: '',
    cover: 'default.jpg',
    presale: false,
    type: 'game',
    currentDiscount: {},
    price: {},
    fullPrice: {},
    hideDiscount: false,
    bundles: [],
    endDate: '',
    productId: '',
    soldOut: false,
    regions_included: [],
    regions_excluded: [],
    giveaway: false,
    platforms: {
      windows: false,
      mac: false,
      linux: false,
    },
    drm: {},
    no_release_date: false,
  },
  switchCarouselGame: () => { },
};

export default AudioBundleTemplateSelector;
